import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const TrelloBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrelloBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shortLink"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shortLink"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"None"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TrelloBoard","document":TrelloBoardDocument}} as const;
export type TrelloBoardQueryVariables = Types.Exact<{
  shortLink: Types.Scalars['ID'];
}>;


export type TrelloBoardQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id' | 'url' | 'name'>
  )> }
);




/**
 * __useTrelloBoardQuery__
 *
 * To run a query within a React component, call `useTrelloBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrelloBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrelloBoardQuery({
 *   variables: {
 *      shortLink: // value for 'shortLink'
 *   },
 * });
 */
export function useTrelloBoardQuery(baseOptions: Apollo.QueryHookOptions<TrelloBoardQuery, TrelloBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrelloBoardQuery, TrelloBoardQueryVariables>(TrelloBoardDocument, options);
      }
export function useTrelloBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrelloBoardQuery, TrelloBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrelloBoardQuery, TrelloBoardQueryVariables>(TrelloBoardDocument, options);
        }
export type TrelloBoardQueryHookResult = ReturnType<typeof useTrelloBoardQuery>;
export type TrelloBoardLazyQueryHookResult = ReturnType<typeof useTrelloBoardLazyQuery>;
export type TrelloBoardQueryResult = Apollo.QueryResult<TrelloBoardQuery, TrelloBoardQueryVariables>;